import { Component, ErrorInfo, ReactNode } from "react"
import { reloadPage } from "../../helpers/page-reload"
import { logger, LogContext } from "../../helpers/logger"

type OverlayErrorBoundaryState = { hasError: boolean }

// a render crash anywhere in the overlay hides it from stream and reloads the page rather than leaving broken ui up
export class OverlayErrorBoundary extends Component<{ children: ReactNode }, OverlayErrorBoundaryState> {
  state: OverlayErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): OverlayErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // react swallows render errors, so faro's global error capture never sees these
    logger.error(LogContext.REACT, 'Overlay render crashed', error, { componentStack: errorInfo.componentStack })
    reloadPage('crash', { error, componentStack: errorInfo.componentStack })
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}
